import { render, staticRenderFns } from "./payComplete.vue?vue&type=template&id=121e2738&scoped=true&"
import script from "./payComplete.vue?vue&type=script&lang=js&"
export * from "./payComplete.vue?vue&type=script&lang=js&"
import style0 from "./payComplete.vue?vue&type=style&index=0&id=121e2738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e2738",
  null
  
)

export default component.exports